import { getTokenFromStorage } from "./authentication";
import { store } from "../store/store";
const currentEnv = process.env.REACT_APP_ENV;

// set header
export function header() {
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
  };
}

// set header with token
export function authHeader(token?: string) {
  let authToken = getTokenFromStorage();
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'Authorization': `Bearer ${authToken}`,
  };
}

// set header for get engima file upload url
export function enigmaHeader(){
  let authToken = getTokenFromStorage();
  return {
    'Accept-Encoding': 'gzip, deflate, br',
    'Accept': '*/*',
    'Connection' : 'keep-alive',
    'Authorization': 'Bearer ' + authToken,
  };
}

// set header for ranger - reedem pass
export function reedemHeader(){
  let rangerToken = localStorage.getItem("RangerToken") != null ?JSON.parse(localStorage.getItem("RangerToken") || "") : null;
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'Authorization': 'Bearer ' + rangerToken,
  };
}

export function captchaAuthHeader(userAction: string) {
  let authToken = getTokenFromStorage();
  let token = store.getState().global.reCaptchaToken;
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'CaptchaToken' : token,
    'UserAction': userAction,
    'Authorization': 'Bearer ' + authToken,
  };
}

export function captchaHeader(userAction: string) {
  let token = store.getState().global.reCaptchaToken;
  return {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'x-api-version': '5.6',
    'CaptchaToken' : token,
    'UserAction': userAction,
  };
}